import { FC } from 'react'
import { Grid, Space } from '@maas-components/core'
import { TSidebarDrawerProps } from 'components/SideBar/types'
import Sidebar from '../../components/SideBar'

const AppSidebar: FC<TSidebarDrawerProps> = ({ options, version, menu, setOptions, children }) => {
  return (
    <>
      <Sidebar menu={menu} version={version} options={options} setOptions={setOptions} />
      <Space spacing={10} variant="height" />
      <Grid item xs={12}>
        {children}
      </Grid>
    </>
  )
}

export default AppSidebar
